import React from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { hasReliableCapacityUsage } from "../../api/whatsAppCapacity";

const scopeMessage = scope => {
  if (scope === "waba") {
    return "Your connected WhatsApp Business Account has reached its available phone-number limit.";
  }
  if (scope === "business") {
    return "Your Meta Business has reached its available WhatsApp phone-number limit.";
  }
  return "Your Meta account currently has no available WhatsApp phone-number slots.";
};

export default function WhatsAppCapacityLimitModal({ open, onClose, preflight }) {
  const showUsage = hasReliableCapacityUsage(preflight);

  return (
    <Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-slate-900">
            WhatsApp number limit reached
          </DialogTitle>
        </DialogHeader>

        <DialogDescription className="space-y-3 text-sm leading-6 text-slate-600">
          <span className="block">{scopeMessage(preflight?.scope)}</span>
          {showUsage && (
            <span className="block font-semibold text-slate-800">
              {preflight.used} of {preflight.maximum} phone-number slots are currently in use.
            </span>
          )}
          <span className="block">
            Remove an unused WhatsApp number or request additional capacity from Meta before adding another number.
          </span>
          <span className="block text-xs text-slate-500">
            To increase the limit, use Meta Business Support or WhatsApp Manager for the affected business.
          </span>
        </DialogDescription>

        <DialogFooter>
          <DialogClose asChild>
            <button
              type="button"
              className="rounded-lg bg-slate-900 px-4 py-2 text-xs font-bold text-white hover:bg-slate-800"
            >
              Close
            </button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
